import React, { useEffect } from "react";
import {
    FaBolt,
    FaShieldAlt,
    FaRocket,
    FaSyncAlt,
    FaMobileAlt,
    FaGoogle
} from "react-icons/fa";
import "./BenefitsKotlin.css";

const BenefitsKotlin = () => {

    useEffect(() => {

        const items = document.querySelectorAll(".bk-hex");

        items.forEach((item, i) => {

            item.style.opacity = "0";
            item.style.transform = "scale(.6) rotate(20deg)";

            setTimeout(() => {

                item.style.transition = "1s ease";

                item.style.opacity = "1";

                item.style.transform = "scale(1) rotate(0deg)";

            }, i * 180);

        });

    }, []);

    const benefits = [
        {
            icon: <FaBolt />,
            title: "Fast Development",
            desc: "Concise syntax and modern tooling speed up app development.",
        },
        {
            icon: <FaShieldAlt />,
            title: "Safer Code",
            desc: "Null safety and clean architecture reduce crashes and bugs.",
        },
        {
            icon: <FaRocket />,
            title: "High Performance",
            desc: "Optimized Android applications with smooth performance.",
        },
        {
            icon: <FaSyncAlt />,
            title: "Java Compatible",
            desc: "Works seamlessly with Java and existing Android libraries.",
        },
        {
            icon: <FaMobileAlt />,
            title: "Modern UI",
            desc: "Create beautiful Android interfaces with Kotlin frameworks.",
        },
        {
            icon: <FaGoogle />,
            title: "Google Supported",
            desc: "Officially preferred language for Android development.",
        },
    ];

    return (
        <>
            <section
                style={{
                    position: "relative",
                    background: "#ffffff",
                    padding: "160px 24px",
                    overflow: "hidden",
                }}
            >

                {/* BACKGROUND */}
                <div className="bk-bg-grid"></div>

                <div className="bk-glow bk-glow1"></div>
                <div className="bk-glow bk-glow2"></div>

                <div
                    style={{
                        maxWidth: "1320px",
                        margin: "0 auto",
                        position: "relative",
                        zIndex: 2,
                    }}
                >

                    {/* TOP */}
                    <div className="bk-top">

                        <div className="bk-badge">
                            🚀 Kotlin Benefits
                        </div>

                        <h2>
                            Benefits of
                            <br />
                            <span>Kotlin Development</span>
                        </h2>

                        <p>
                            Kotlin helps businesses build scalable,
                            secure and modern Android applications
                            with better performance and faster
                            development workflow.
                        </p>

                    </div>

                    {/* HEXAGON WRAP */}
                    <div className="bk-wrap">

                        {benefits.map((item, i) => (

                            <div
                                key={i}
                                className="bk-hex"
                                onMouseEnter={(e) => {

                                    e.currentTarget.style.transform =
                                        "translateY(-18px) scale(1.05)";

                                    e.currentTarget.style.boxShadow =
                                        "0 35px 90px rgba(232,33,42,.18)";

                                }}
                                onMouseLeave={(e) => {

                                    e.currentTarget.style.transform =
                                        "translateY(0px) scale(1)";

                                    e.currentTarget.style.boxShadow =
                                        "none";

                                }}
                            >

                                {/* INSIDE */}
                                <div className="bk-inner">

                                    <div className="bk-icon">
                                        {item.icon}
                                    </div>

                                    <h3>{item.title}</h3>

                                    <p>{item.desc}</p>

                                </div>

                                {/* glow */}
                                <div className="bk-hover"></div>

                            </div>

                        ))}

                    </div>

                </div>
            </section>
        </>
    );
};

export default BenefitsKotlin;